import { render } from "./Evolution.vue?vue&type=template&id=0a477e3f"
import script from "./Evolution.vue?vue&type=script&lang=js"
export * from "./Evolution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__